import script from "./GenerateDefaultsGuards.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateDefaultsGuards.vue?vue&type=script&setup=true&lang=js"

import "./GenerateDefaultsGuards.vue?vue&type=style&index=0&id=3ac44f20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac44f20"]])

export default __exports__